import { render, staticRenderFns } from "./PiHole.vue?vue&type=template&id=0a207ccf&scoped=true&"
import script from "./PiHole.vue?vue&type=script&lang=js&"
export * from "./PiHole.vue?vue&type=script&lang=js&"
import style0 from "./PiHole.vue?vue&type=style&index=0&id=0a207ccf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a207ccf",
  null
  
)

export default component.exports